import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject, bindable } from 'aurelia-framework';
import { PenPipeSizeDto } from 'models/pen/PenPipeSize';

@autoinject
export class PenPipeSizeForm {
  @bindable
  private penPipeSize: PenPipeSizeDto;
  protected isDuplicate = false;

  constructor(private eventAggregator: EventAggregator) {}

  private attached() {
    this.eventAggregator.subscribe('penPipeSizeIsDuplicate', (isDuplicate) => {
      this.isDuplicate = isDuplicate;
    });
  }
}
